import { formatStageName } from './formatters';

export const hubspotRequestTypeOptions = [
  { value: '', label: 'All Types' },
  { value: 'NewDapp', label: 'New Dapp' },
  { value: 'UpdateDapp', label: 'Update Dapp' },
  { value: 'RemoveDapp', label: 'Remove Dapp' },
  { value: 'Support', label: 'Support' },
  { value: 'NewRelease', label: 'New Release' },
  { value: 'UpdateRelease', label: 'Update Release' },
];

export const hubspotSourceOptions = [
  { value: '', label: 'All Sources' },
  { value: 'Portal', label: 'Portal' },
  { value: 'CLI', label: 'CLI' },
];

export function getPipelineStageOptions(pipelineStages: string[]) {
  return [
    { value: '', label: 'All Stages' },
    ...pipelineStages.map((stage) => ({
      value: stage,
      label: formatStageName(stage),
    })),
  ];
}

export const hubspotSortOptions = [
  { id: 'createdAt', desc: true, label: 'Newest first' },
  { id: 'createdAt', desc: false, label: 'Oldest first' },
  { id: 'lastModifiedAt', desc: true, label: 'Recently modified' },
  { id: 'closedDate', desc: true, label: 'Recently closed' },
  { id: 'dapp', desc: false, label: 'Name A–Z' },
  { id: 'status', desc: false, label: 'Status' },
] as const;
